// Xuno schedulers run on Melbourne time, so every page shows it too
export const APP_TIME_ZONE = "Australia/Melbourne";

// AEST most of the year, AEDT during daylight saving
export const getTimeZoneLabel = (date = new Date()) => {
  const name = new Intl.DateTimeFormat("en-AU", { timeZone: APP_TIME_ZONE, timeZoneName: "short" })
    .formatToParts(date)
    .find((part) => part.type === "timeZoneName")?.value;
  return name === "AEDT" ? "AEDT UTC+11" : "AEST UTC+10";
};
